/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandVercel = createReactComponent("brand-vercel", "IconBrandVercel", [
  ["path", { d: "M3 19h18l-9 -15z", key: "svg-0" }]
]);

export { IconBrandVercel as default };
//# sourceMappingURL=IconBrandVercel.js.map
